import { render, staticRenderFns } from "./consultingService.vue?vue&type=template&id=3b87f33d&scoped=true&"
import script from "./consultingService.vue?vue&type=script&lang=js&"
export * from "./consultingService.vue?vue&type=script&lang=js&"
import style0 from "./consultingService.vue?vue&type=style&index=0&id=3b87f33d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87f33d",
  null
  
)

export default component.exports